const Routes = [
  {
    path: '/activations',
    name: 'Activations',
    component: () => import('@/app/activations/TheActivations'),
    redirect: '/activations/',
    meta: {
      requiresAuth: true
    },
    children: [
      {
        path: '',
        component: () => import('@/app/activations/views/Index')
      },
      {
        path: 'new',
        name: 'NewActivation',
        component: () => import('@/app/activations/views/NewActivation')
      },
      {
        path: ':activationId',
        name: 'ActivationDetail',
        component: () => import('@/app/activations/views/ActivationDetail'),
        props: true
      }
    ]
  }
]
export default Routes



// WEBPACK FOOTER //
// ./src/app/activations/Routes.js